import React, { ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { LinearGradient } from 'expo-linear-gradient'

import { WebWrapper } from '@/components/WebWrapper'
import { StatusBar } from "@/components/Mini/StatusBar"

import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'
import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'

import { defaultTheme } from '@/components/Mini/theme'

function D10Background({ children }: { children: ReactNode }) {

  const theme = d10.useStore(s => s.theme)

  return (
    <Background theme={theme} >
      {children}
    </Background>
  )
}

function CthBackground({ children }: { children: ReactNode }) {

  const theme = cth.useStore(s => s.theme)

  return (
    <Background theme={theme} >
      {children}
    </Background>
  )
}

function PocketPickBackground({ children }: { children: ReactNode }) {

  const theme = pocketPick.useStore(s => s.theme)

  return (
    <Background theme={theme} >
      {children}
    </Background>
  )
}

  function Background({ theme=defaultTheme, children }: { theme?: typeof defaultTheme; children: ReactNode }) {

    let background;

    if (theme.backgroundType == "gradient"){
      background = <BackgroundGradient theme={theme}>{children}</BackgroundGradient>
    } else if (theme.backgroundType == "color"){
      background = <BackgroundSolid theme={theme}>{children}</BackgroundSolid>
    } else if (theme.backgroundType == "image"){
      background = <BackgroundImage theme={theme}>{children}</BackgroundImage>
    }

  return background
}

 function BackgroundGradient({ theme, children }: { theme: typeof defaultTheme; children: ReactNode }) {

  const colors = theme.bgGradient

  return (
    <LinearGradient colors={colors} style={styles.fill}>
      <SafeAreaView style={[styles.fill/*, { alignItems: 'center' }*/]} edges={['top', 'bottom']}>
        <WebWrapper>
          <StatusBar theme={theme} />
          <View style={{flex: 1}}>
            {children}
          </View>
        </WebWrapper>
      </SafeAreaView>
    </LinearGradient>
  )
}

 function BackgroundSolid({ theme, children }: { theme: typeof defaultTheme; children: ReactNode }) {

  const backgroundColor = theme.background 

  return (
    <View style={[styles.fill, { backgroundColor }]}>
      <SafeAreaView style={[styles.fill/*, { alignItems: 'center' }*/]} edges={['top', 'bottom']}>
        <WebWrapper>
          <StatusBar theme={theme} />
          <View style={{flex: 1}}>
            {children}
          </View>
        </WebWrapper>
      </SafeAreaView>
    </View>
  )
}



function BackgroundImage({ theme, children }: { theme: typeof defaultTheme; children: ReactNode }) {

    const Img = theme.backgroundImage

    return (
      <View style={styles.fill}>
        <Img width="100%" height="100%" style={StyleSheet.absoluteFill} preserveAspectRatio="xMidYMid slice" />
        <SafeAreaView style={[styles.fill/*, { alignItems: 'center' }*/]} edges={['top', 'bottom']}>
          <WebWrapper>
            <StatusBar theme={theme} />
            <View style={{ margin: 16, flex: 1, borderRadius: 16, backgroundColor: theme.background }}>
              {children}
            </View>
          </WebWrapper>
        </SafeAreaView>
      </View>
    )
  }


const styles = StyleSheet.create({
  fill: {
    flex: 1
  }
})

export { Background, CthBackground, D10Background, PocketPickBackground }
